import { AllotmentRolesConstants as Roles } from '@/stores/definitions.js';
import { RouteRecordRaw } from 'vue-router';
import { lazyRoute, meta, redirect } from '@/router/router-helpers.ts';

const AdminView = () => import('@/views/Admin/Admin.vue');
const UsersView = () => import('@/views/Admin/Users.vue');
const ReferenceDataView = () => import('@/views/Admin/ReferenceData/ReferenceData.vue');
const AuditView = () => import('@/views/Admin/Audit.vue');
const BusinessRulesView = () => import('@/views/Admin/BusinessRules.vue');
const FaresView = () => import('@/views/Fares/Fares.vue');
const ALLOTMENT_APP_ID = 'allotment' as const;
const ADMIN_ROLES = [Roles.ADMIN, Roles.READONLY_ADMIN];

const adminRoutes: RouteRecordRaw[] = [
  lazyRoute('admin', AdminView, {
    path: '/admin',
    meta: meta({
      app: ALLOTMENT_APP_ID,
      allowedRoles: ADMIN_ROLES,
      title: 'Admin',
    }),
    children: [
      redirect('', 'users', 'admin-users-landing', meta({
        app: ALLOTMENT_APP_ID,
        allowedRoles: ADMIN_ROLES,
      })),
      lazyRoute('users', UsersView, {
        path: 'users',
        meta: meta({
          app: ALLOTMENT_APP_ID,
          allowedRoles: ADMIN_ROLES,
          title: 'Users',
          referenceDataRequired: true,
        }),
      }),
      lazyRoute('reference-data', ReferenceDataView, {
        path: 'reference-data',
        meta: meta({
          app: ALLOTMENT_APP_ID,
          allowedRoles: ADMIN_ROLES,
          title: 'Reference Data',
          referenceDataRequired: true,
        }),
      }),
      lazyRoute('audit-logs', AuditView, {
        path: 'audit',
        meta: meta({
          app: ALLOTMENT_APP_ID,
          allowedRoles: ADMIN_ROLES,
          title: 'Audit Log',
        }),
      }),
      lazyRoute('business-rules', BusinessRulesView, {
        path: 'business-rules',
        meta: meta({
          app: ALLOTMENT_APP_ID,
          allowedRoles: ADMIN_ROLES,
          title: 'Business Rules',
          referenceDataRequired: true,
        }),
      }),
    ],
  }),
  lazyRoute('fares', FaresView, {
    path: '/fares',
    meta: meta({
      app: ALLOTMENT_APP_ID,
      allowedRoles: ADMIN_ROLES,
      title: 'Fares',
      referenceDataRequired: true,
    }),
  }),
];

export default adminRoutes;
